import { useMemo } from 'react';

import { adaptErroresLibranzasDictionary, ErroresLibranzasDictionary } from '../adapters';
import useErroresLibranzasQuery from '../queries/useErroresLibranzasQuery';

const useErroresLibranzasDictionary = (): ErroresLibranzasDictionary => {
    const node = useErroresLibranzasQuery();
    return useMemo(() => adaptErroresLibranzasDictionary(node), [node]);
};

export default useErroresLibranzasDictionary;
